module.exports = __webpack_public_path__ + "img/weixin-bjlyfzyjjd.2b03d0c7.png";